import { render } from "./LoremIpsumHelp.vue?vue&type=template&id=a70adb2e"
import script from "./LoremIpsumHelp.vue?vue&type=script&lang=js"
export * from "./LoremIpsumHelp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__